import validate from 'lib/utils/validationRules';

export const getInputFieldLabel = (vField, defaultLabel) => {
  if (!vField.$error) {
    return defaultLabel;
  }

  const errorMessage = getErrorMessage(vField);

  if (validate.isString(errorMessage)) {
    return errorMessage;
  }

  return defaultLabel;
};

const getErrorMessage = vField => {
  if (hasErrorByValue(vField, 'required')) {
    return 'error.message.required';
  }

  if (hasErrorByValue(vField, 'minLength')) {
    return 'error.message.minLength';
  }

  if (hasErrorByValue(vField, 'maxLength')) {
    return 'error.message.maxLength';
  }

  if (hasErrorByValue(vField, 'email')) {
    return 'error.message.email';
  }

  if (hasErrorByValue(vField, 'promocode')) {
    return 'error.message.promocode';
  }

  return null;
};

const hasErrorByValue = (vField, value) => validate.isObjectWithFields(vField, [value]) && !vField[value];
